export const MATH_SYMBOLS = {
  EQUAL: '=',
  APPROXIMATE: '≈',
  NOT_EQUAL: '≠',
  GREATER_THAN_OR_EQUAL: '≥',
  GREATER_THAN: '>',
  LESS_THAN_OR_EQUAL: '≤',
  LESS_THAN: '<',
  PERCENT: '%',
  MULTIPLY: '×',
  DIVIDE: '÷',
  PLUS: '+'
}
